import { DEFAULT_LOCALE } from '../Constants/Locale.constants';

export const normalizePostcode = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value !== 'object' || value === null) {
    return '';
  }

  // Older postcode cookies used a locale-keyed object instead of a string.
  const legacyPostcode = value as Record<string, unknown>;

  return typeof legacyPostcode[DEFAULT_LOCALE] === 'string' ? legacyPostcode[DEFAULT_LOCALE] : '';
};
